// extracted by mini-css-extract-plugin
export default {"generalWallboardCSI":"style_generalWallboardCSI__E0yYR","captionWrapper":"style_captionWrapper__wTiQT"};